import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

export default function TravellerGettingStarted() {
  return (
    <Group direction="vertical" gap={8}>
      <Heading variant="heading4">Getting started</Heading>
      <Accordion size="large" heading="How do I complete my profile?">
        <BodyText variant="large">
          When you are invited to Business Traveller, you are required to fill in your details such as full name and date of birth. You will need to ensure your details matches your passport to ensure seamless bookings - either for yourself or for your company to book trips on your behalf.
        </BodyText>
        <br />
        <BodyText variant="large">
          If you have accidentally made an error on onboarding, you can update your account details by
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">View Your Account:</BodyText>
              <BodyText variant="large"> Navigate to the top right-hand side of the navigation bar and click on "Account."</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Select "Profile" from the Dropdown:</BodyText>
              <BodyText variant="large"> In the dropdown menu that appears, locate and click on "Profile."</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Access Your Profile Page:</BodyText>
              <BodyText variant="large"> Once you're on the Profile page, select "My Profile" to access your personal information.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Update Your Personal Information:</BodyText>
              <BodyText variant="large"> Review the information displayed on your profile page and update any details as required. Ensure that your full name and date of birth match your passport information to avoid any discrepancies during bookings, whether for yourself or on behalf of your company.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Save Changes:</BodyText>
              <BodyText variant="large"> After making any necessary updates to your personal information, be sure to save your changes to ensure they are applied to your profile.</BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
      <Accordion size="large" heading="How can I get support while on a trip?">
        <BodyText variant="large">
          Please reach out to our Customer Service team anytime whenever you need us during your business trip.
        </BodyText>
      </Accordion>
    </Group>
  )
}
